function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    var selectedmediaid = $(".product__media-wrapper").data("selectedmediaid");
    var onloadindexid = $(".main-slider")
      .find('.swiper-slide[data-media-id="' + selectedmediaid + '"]')
      .attr("data-index");
    var onloadthumbsliderid = $(".thumb-slider")
      .find('.swiper-slide[data-media-id="' + selectedmediaid + '"]')
      .attr("data-index");

    setTimeout(function () {
      var onloadgalleryThumbs = new Swiper(".thumb-slider", {
        spaceBetween: 10,
        direction: "horizontal",
        slidesPerView: 5,
        breakpoints: {
          640: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
      });

      var onloadmainslider = new Swiper(".main-slider", {
        spaceBetween: 10,
        direction: "horizontal",
        thumbs: {
          swiper: onloadgalleryThumbs,
        },
      });

      onloadmainslider.slideTo(onloadindexid);
      onloadgalleryThumbs.slideTo(onloadthumbsliderid);

      var pricevar = $(".priceitemregular").text();
      var pprice = pricevar.replace(/\s+\./g, ".");

      var cpricevar = $(".priceitemcompare").text();
      var cpprice = cpricevar.replace(/\s+\./g, ".");

      $(".custom-sticky-price").text(pprice);
      $(".custom-sticky-compare-price").text(cpprice);
    }, 500);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    var varid = this.currentVariant.featured_media.id;

    var indexid = $(".main-slider")
      .find('.swiper-slide[data-media-id="' + varid + '"]')
      .attr("data-index");
    var thumbsliderid = $(".thumb-slider")
      .find('.swiper-slide[data-media-id="' + varid + '"]')
      .attr("data-index");

    var galleryThumbs = new Swiper(".thumb-slider", {
      spaceBetween: 10,
      direction: "horizontal",
      slidesPerView: 5,
      breakpoints: {
        640: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      },
    });

    var mainslider = new Swiper(".main-slider", {
      spaceBetween: 10,
      direction: "horizontal",
      thumbs: {
        swiper: galleryThumbs,
      },
    });

    console.log(
      "indexid==" +
        indexid +
        "varid==" +
        varid +
        "thumbsliderid==" +
        thumbsliderid
    );
    mainslider.slideTo(indexid);
    galleryThumbs.slideTo(thumbsliderid);

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    $(".selectedvarname").text(this.querySelector(":checked").value);
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        var pricevar = $(".priceitemregular").text();
        var pprice = pricevar.replace(/\s+\./g, ".");

        var cpricevar = $(".priceitemcompare").text();
        var cpprice = cpricevar.replace(/\s+\./g, ".");

        $(".custom-sticky-price").text(pprice);
        $(".custom-sticky-compare-price").text(cpprice);

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      $(".product-form__quantity").css({ display: "none" });
      $(".product-form__submit").css({ opacity: "0.6" });
      $(".quantity__label").css({ display: "none" });
      $(".custom-sticky-atc-btn").css({ "pointer-events": "none" });
      $(".sticky-atc-button").find(".sticky-atc-text").text("SOLD OUT");
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
      $(".product-form__quantity").css({ display: "block" });
      $(".product-form__submit").css({ opacity: "1" });
      $(".quantity__label").css({ display: "block" });
      $(".custom-sticky-atc-btn").css({ "pointer-events": "unset" });
      $(".sticky-atc-button").find(".sticky-atc-text").text("ADD TO CART");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class announcementbar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });
      var slidertime = $(this).data("slidertime");

      var swiper = new Swiper(".announcement-swiper", {
        loop: true,
        autoplay: {
          delay: slidertime,
        },
        slidesPerView: 1,
        spaceBetween: 0,
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("announcement-bar", announcementbar);

class CustomFeaturedProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      function increaseQty(qtyId) {
        var location = document.getElementById(qtyId);
        var currentQty = location.value;
        var qty = Number(currentQty) + 1;
        location.value = qty;
        $(".cartqtycount").text(qty);
      }

      function decreaseQty(qtyId) {
        var location = document.getElementById(qtyId);
        var currentQty = location.value;
        if (currentQty > 1) {
          var qty = Number(currentQty) - 1;
          location.value = qty;
          $(".cartqtycount").text(qty);
        }
      }

      $(".addtocartsubmit").click(function () {
        var id = $(this).data("id");
        // var qty = $('.cartqtycount').text();
        var qty = 1;
        console.log("id==" + id + "--->" + "qty==" + qty);
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: qty,
            id: id,
          },
          dataType: "json",
          success: function (data) {
            window.location.href = "/cart";
          },
        });
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-featured-product", CustomFeaturedProduct);

class featuredgalleryslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      $(
        ".custom_featured_gallery_image-" + this.getAttribute("data-sectionid")
      ).owlCarousel({
        items: 2,
        margin: 30,
        loop: true,
        dots: false,
        nav: false,
        responsive: {
          768: {
            items: 2,
          },
          769: {
            items: 4,
          },
          1200: {
            items: 4,
          },
        },
      });

      $(".owl-carousel__next").click(() =>
        $(
          ".custom_featured_gallery_image-" +
            this.getAttribute("data-sectionid")
        ).trigger("next.owl.carousel")
      );
      $(".owl-carousel__prev").click(() =>
        $(
          ".custom_featured_gallery_image-" +
            this.getAttribute("data-sectionid")
        ).trigger("prev.owl.carousel")
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-featured-gallery-slider", featuredgalleryslider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-questions").click(function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.next().slideUp(350);

          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-down")
            .css({ display: "flex" });
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-up")
            .css({ display: "none" });
        } else {
          $this.parent().parent().find(".faq-answers").removeClass("show");
          $this.parent().parent().find(".faq-answers").slideUp(350);

          $this
            .parent()
            .parent()
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-down")
            .css({ display: "flex" });
          $this
            .parent()
            .parent()
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-up")
            .css({ display: "none" });

          $this.next().toggleClass("show");
          $this.next().slideToggle(350);

          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-down")
            .css({ display: "none" });
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-up")
            .css({ display: "flex" });
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section", FaqSection);

class CustomFeaturedBox extends HTMLElement {
  constructor() {
    super();
    $(document).ready(function () {
      $(".custom_featured_box_main").css({ opacity: "1" });
    });
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      $(
        ".custom_box_container-" + this.getAttribute("data-sectionid")
      ).owlCarousel({
        items: 1.35,
        margin: 30,
        loop: true,
        dots: true,
        nav: false,
        center: true,
        responsive: {
          768: {
            items: 1.35,
          },
          1024: {
            dots: false,
            loop: false,
            center: false,
            items: 4,
          },
          1200: {
            dots: false,
            loop: false,
            center: false,
            items: 4,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-featured-box", CustomFeaturedBox);

class CustomSlider extends HTMLElement {
  constructor() {
    super();

    $(function () {
      var galleryThumbs = new Swiper(".thumb-slider", {
        spaceBetween: 10,
        direction: "horizontal",
        slidesPerView: 5,
        breakpoints: {
          640: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
      });

      var galleryTop = new Swiper(".main-slider", {
        spaceBetween: 10,
        direction: "horizontal",
        thumbs: {
          swiper: galleryThumbs,
        },
      });

      galleryTop.on("slideChangeTransitionStart", function () {
        galleryThumbs.slideTo(galleryTop.activeIndex);
      });
      galleryThumbs.on("transitionStart", function () {
        galleryTop.slideTo(galleryThumbs.activeIndex);
      });
    });

    $(".zoominbtn")
      .unbind()
      .click(function () {
        $(".swiper-slide").find(".pr-swiper-image").removeClass("pr-img-img");
        $(this)
          .parent(".swiper-slide")
          .find(".pr-swiper-image")
          .addClass("pr-img-img");
        $(".pr-img-img").zoom();
        $(this).css({ display: "none" });
        $(this)
          .parent(".swiper-slide")
          .find(".zoomoutbtn")
          .css({ display: "block" });
      });

    $(".zoomoutbtn")
      .unbind()
      .click(function () {
        $(".swiper-slide").find(".pr-swiper-image").removeClass("pr-img-img");
        $(this)
          .parent(".swiper-slide")
          .find(".pr-swiper-image")
          .removeClass("pr-img-img");
        $(this).parent(".swiper-slide").find(".zoomImg").remove();
        $(this).css({ display: "none" });
        $(this)
          .parent(".swiper-slide")
          .find(".zoominbtn")
          .css({ display: "block" });
      });
  }
}

customElements.define("custom-slider", CustomSlider);

class customfeaturedslider extends HTMLElement {
  constructor() {
    super();

    $(function () {
      var galleryThumbsnew = new Swiper(".thumb-featured-slider", {
        spaceBetween: 10,
        direction: "horizontal",
        slidesPerView: 5,
        breakpoints: {
          640: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
      });

      var galleryTopnew = new Swiper(".main-featured-slider", {
        spaceBetween: 10,
        direction: "horizontal",
        thumbs: {
          swiper: galleryThumbsnew,
        },
      });

      galleryTopnew.on("slideChangeTransitionStart", function () {
        galleryThumbsnew.slideTo(galleryTopnew.activeIndex);
      });
      galleryThumbsnew.on("transitionStart", function () {
        galleryTopnew.slideTo(galleryThumbsnew.activeIndex);
      });
    });
  }
}

customElements.define("custom-featured-slider", customfeaturedslider);

class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-collapse-questions").click(function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.next().slideUp(350);

          $this
            .find(".fa-collapse-arrows")
            .find(".fa-collapse-plus")
            .css({ display: "flex" });
          $this
            .find(".fa-collapse-arrows")
            .find(".fa-collapse-minus")
            .css({ display: "none" });
        } else {
          $this
            .parent()
            .parent()
            .find(".faq-collapse-answers")
            .removeClass("show");
          $this.parent().parent().find(".faq-collapse-answers").slideUp(350);

          $this
            .parent()
            .parent()
            .find(".fa-collapse-arrows")
            .find(".fa-collapse-plus")
            .css({ display: "flex" });
          $this
            .parent()
            .parent()
            .find(".fa-collapse-arrows")
            .find(".fa-collapse-minus")
            .css({ display: "none" });

          $this.next().toggleClass("show");
          $this.next().slideToggle(350);

          $this
            .find(".fa-collapse-arrows")
            .find(".fa-collapse-plus")
            .css({ display: "none" });
          $this
            .find(".fa-collapse-arrows")
            .find(".fa-collapse-minus")
            .css({ display: "flex" });
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-info", ProductInfo);

class featuredimagewithtextslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      var swiper = new Swiper(
        ".custom_featured_iwt_image-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 2.1,
          spaceBetween: 12,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: 2.1,
              spaceBetweenSlides: 12,
            },
            1024: {
              slidesPerView: 3.9,
              spaceBetweenSlides: 12,
            },
            1440: {
              slidesPerView: 6.1,
              spaceBetweenSlides: 12,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define(
  "featured-image-with-text-slider",
  featuredimagewithtextslider
);

class Customlpgv3workout extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      var swiper = new Swiper(
        ".mySwiperworkout-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 4.5,
          spaceBetween: 1,
          loop: true,
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-lpg-v3-workout", Customlpgv3workout);

class lpg2imageslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      var swiper = new Swiper(".imge-lpg-slider", {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        freeMode: true,
        speed: 3000,
        freeModeMomentum: false,
        loop: true,
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 10,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("lpg2-image-slider", lpg2imageslider);

class CustomVideoContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const video = document.getElementById("customvideo");
      const circlePlayButton = document.getElementById("customvideoplay");

      function togglePlay() {
        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      }

      circlePlayButton.addEventListener("click", togglePlay);
      video.addEventListener("playing", function () {
        circlePlayButton.style.opacity = 0;
      });
      video.addEventListener("pause", function () {
        circlePlayButton.style.opacity = 1;
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-video-container", CustomVideoContainer);

class Faqmulti extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).on("click", ".faq-questions", function (e) {
        e.preventDefault();
        let $this = $(this);

        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.next().slideUp(350);
          $this.removeClass("active");

          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-down")
            .css({ display: "flex" });
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-up")
            .css({ display: "none" });
        } else {
          $this.parent().parent().find(".faq-answers").removeClass("show");
          $this.parent().parent().find(".faq-answers").slideUp(350);
          $(_this).find(".faq-questions").removeClass("active");
          $this.toggleClass("active");

          $this
            .parent()
            .parent()
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-down")
            .css({ display: "flex" });
          $this
            .parent()
            .parent()
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-up")
            .css({ display: "none" });

          $this.next().toggleClass("show");
          $this.next().slideToggle(350);

          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-down")
            .css({ display: "none" });
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-up")
            .css({ display: "flex" });
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-multi", Faqmulti);

class CustomStickyAtc extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var lastScrollTop = 0;
      var $element = $(".custom-sticky-atc-container");

      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > lastScrollTop) {
          $element.addClass("showbutton");
        } else {
          $element.removeClass("showbutton");
        }
        lastScrollTop = scrollTop;
      });

      $(".sticky-atc-button")
        .unbind()
        .click(function () {
          $(".custom-sticky-atc-btn .loading-overlay__spinner").removeClass(
            "hidden"
          );
          $(".custom_product-form__submit").click();
          $(".sticky-atc-text").css({ opacity: "0" });

          setTimeout(function () {
            $(".custom-sticky-atc-btn .loading-overlay__spinner").addClass(
              "hidden"
            );
            $(".sticky-atc-text").css({ opacity: "1" });
          }, 1500);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-sticky-atc", CustomStickyAtc);

class CustomCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      // function updateCountdown() {

      //     var countdownTime = 7 * 60 * 60;
      //     var countdownInterval = setInterval(function() {

      //         var hours = Math.floor(countdownTime / 3600);
      //         var minutes = Math.floor((countdownTime % 3600) / 60);
      //         var seconds = countdownTime % 60;

      //       hours = ("0" + hours).slice(-2);
      //       minutes = ("0" + minutes).slice(-2);
      //       seconds = ("0" + seconds).slice(-2);

      //       console.log(hours + "h " + minutes + "m " + seconds + "s")
      //         $('.custom_countdown_days').html('00');
      //         $('.custom_countdown_hours').html(hours);
      //         $('.custom_countdown_minutes').html(minutes);
      //         $('.custom_countdown_seconds').html(seconds);

      //         countdownTime--;
      //         if (countdownTime < 0) {
      //             clearInterval(countdownInterval);
      //             updateCountdown();
      //         }
      //     }, 1000);
      // }
      // updateCountdown();

      function startTimer() {
        var interval = 7 * 60 * 60 * 1000;
        setInterval(function () {
          var currentTime = new Date().getTime();
          var lastStartTime = localStorage.getItem("lastStartTime");
          var timePassed = currentTime - parseInt(lastStartTime);
          var timeRemaining = interval - timePassed;

          var hours = Math.floor(
            (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor(
            (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
          );
          var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

          hours = ("0" + hours).slice(-2);
          minutes = ("0" + minutes).slice(-2);
          seconds = ("0" + seconds).slice(-2);

          $(".custom_countdown_days").html("00");
          $(".custom_countdown_hours").html(hours);
          $(".custom_countdown_minutes").html(minutes);
          $(".custom_countdown_seconds").html(seconds);

          if (timeRemaining <= 0) {
            localStorage.setItem("lastStartTime", currentTime.toString());
          }
        }, 1000);
      }

      var lastStartTime = localStorage.getItem("lastStartTime");
      if (lastStartTime) {
        var currentTime = new Date().getTime();
        var timePassed = currentTime - parseInt(lastStartTime);

        if (timePassed < 7 * 60 * 60 * 1000) {
          startTimer();
        } else {
          startTimer();
          localStorage.setItem("lastStartTime", currentTime.toString());
        }
      } else {
        startTimer();
        localStorage.setItem("lastStartTime", new Date().getTime().toString());
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-countdown", CustomCountdown);

class productcountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      // discount bar
      function updateCountdown() {
        const now = new Date();
        const target = new Date();
        target.setHours(24, 0, 0, 0);

        if (now >= target) {
          target.setDate(target.getDate() + 1);
        }

        const difference = target - now;
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        const countdownElements = document.querySelectorAll(".countdown-today");
        countdownElements.forEach((element) => {
          element.textContent = `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        });

        setTimeout(updateCountdown, 1000);
      }

      updateCountdown();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-countdown", productcountdown);

class CurrentOrderDate extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const today = new Date();
      const formattedDate = today.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
      $('.current-updated-date-order').each(function () {
        const originalText = $(this).text();
        const updatedText = originalText.replace('$updatedtiming', formattedDate);
        $(this).text(updatedText);
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("current-order-date", CurrentOrderDate);

$('#custom--product-addon').change(function() {
  var sale_price = Number($(this).attr('data-price'));
  var comp_price = Number($(this).attr('data-cprice'));

  var sale_mprice = Number($(this).attr('data-mprice'));
  var comp_mprice = Number($(this).attr('data-cmprice'));

   var symbol = $("body").data("currency_sym");
   var curcode = $("body").data("currency_code");
  console.log($(this).is(':checked'))
  console.log($(this).is(':checked'))
  console.log(sale_price);
  if($(this).is(':checked')){
    var total = sale_price + sale_mprice;
    var totalcomp = comp_price + comp_mprice;
    $('.product_prices').find('.sale_price').html(Shopify.formatMoney(total, symbol + "{{amount}}"));
    $('.product_prices').find('.compare_price').html(Shopify.formatMoney(totalcomp, symbol + "{{amount}}"));
  }else{
     $('.product_prices').find('.sale_price').html(Shopify.formatMoney(sale_mprice, symbol + "{{amount}}"));
    $('.product_prices').find('.compare_price').html(Shopify.formatMoney(comp_price, symbol + "{{amount}}"));
  }  
});

$(document).ready(function(){
  $('.customjunipreviewpdp').on('click', function(e) {
    e.preventDefault();
    const target = $('.custom-junip-reviewpdp-container');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 800);
    }
  });

    // ================ START : Review Scroll Down Js ==================

  if ($('body').hasClass('page-multi-gym-uk')) {
    $(".mobile-star-wrapper").on("click", function () {
      console.log("Clicked");

      const target = $(".junip-product-review");
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
      }
    });
  }


    if ($('body').hasClass('page-multi-gym-uk')) {
    $(".multi-gym-logo .section_title").on("click", function () {
      console.log("Clicked");

      const target = $(".junip-product-review");
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
      }
    });
  }

  // ======= END : Review Scroll Down Js ==================
  
  // ======= START : Bullet points Price converter ==================

  if (document.body.classList.contains('page-multi-gym-band') && document.querySelectorAll('.custom-flash-sale').length > 0) {
    let activeCurrency = 'GBP';
    let conversionRate = 1;

    if (window.Shopify && Shopify.currency) {
      activeCurrency = Shopify.currency.active || 'GBP';
      conversionRate = Shopify.currency.rate || 1;
    }

    function convertPrice(amountGBP) {
      try {
        let cleaned = String(amountGBP).replace(/[^0-9.-]+/g, '');
        let numericAmount = parseFloat(cleaned);
        if (isNaN(numericAmount)) throw new Error('Invalid amount');

        const converted = numericAmount * conversionRate;
        const rounded = Math.ceil(converted);

        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: activeCurrency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(rounded);
      } catch (e) {
        let fallback = parseFloat(String(amountGBP).replace(/[^0-9.-]+/g, ''));
        if (isNaN(fallback)) fallback = 0;
        return `£${Math.ceil(fallback)}.00`;
      }
    }

    // Get and convert all price values for band page
    const priceElements = document.querySelectorAll('.custom-flash-sale .gym-membership-price');
    priceElements.forEach(el => {
      const formatted = convertPrice(el.textContent);
      el.textContent = formatted;
    });
  }
  // ======= END : Bullet points Price converter ==================

  //========== START: Sales LP AJAX add to cart event ===================
  // $(document).on("click",".sfp-ajax-btn",function() {
  //   var ajaxVariantID = $(this).attr('data-variant-id');
  //   addToCartJS(1,ajaxVariantID,$(this));
  // });
  // function addToCartJS(qty,variantID, btn) {
  //   var xhr = new XMLHttpRequest();
  //   var url = "/cart/add.js";
  //   xhr.open("POST", url, true);
  //   xhr.setRequestHeader("Content-Type", "application/json");
  //   xhr.onreadystatechange = function () {
  //     if (xhr.readyState === 4 && xhr.status === 200) {
  //       var parsedState = JSON.parse(xhr.responseText);
  //         window.location.href="/checkout";
  //     }
  //   };
  //   var data = JSON.stringify({"quantity": qty, "id": variantID });
  //   xhr.send(data);
  // }
  //========== END: Sales LP AJAX add to cart event ===================


  //========== START: Sales LP Redirection Buttons Events ===================

  if ($('body').hasClass('sales-page-template')) {
    $(".custom-switch-section .sales-image-with-text-wrapper .sales-button").on("click", function () {
      console.log("Clicked");
      const target = $(".lp-custom-image-text .sales-image-with-text-wrapper");
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
      }
    });

    $(".lp-custom-header .custom-header-wrap-right , .lp-experience-section .sales-image-with-text-wrapper .sales-button, .custom-comparison-section .button-text").on("click", function () {
      console.log("Clicked");
      const target = $(".single-featured-product-section");
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
      }
    });
  }

  //========== END: Sales LP Redirection Buttons Events ===================

  // =============== START : Product Reformal Js =======================
  
  if ($('.main_wrapper').hasClass('custom-pilates-reformer')) {
    const interval = setInterval(() => {
      const target = document.querySelector('.junip-product-review');
      if (target) {
        $(document).on("click", ".content_wrapper .trustpilot-badge", function () {
          $('html, body').animate({
            scrollTop: $(target).offset().top
          }, 500);
        });
        clearInterval(interval);
      }
    }, 100);

    const  custon_wrap = document.querySelector('.custom-include-section');
      if(custon_wrap){
        $(document).on("click", ".product_include_btn", function () {
          $('html, body').animate({
            scrollTop: $(custon_wrap).offset().top
          }, 500);

        });
      }

      const btn_wrap = document.querySelector('.product_atc_button');
      if(btn_wrap){
        $(document).on("click", ".product-comparison .cta .cta-button", function () {
          $('html, body').animate({
            scrollTop: $(btn_wrap).offset().top
          }, 500);

        });
      }
  }
  // =============== END : Product Reformal Js =======================

});
